import "@arco-design/web-react/es/Empty/style";
import _Empty from "@arco-design/web-react/es/Empty";
import "@arco-design/web-react/es/Tree/style";
import _Tree from "@arco-design/web-react/es/Tree";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppService } from '@/service';
import styles from './style/index.module.less';
import { getDevices } from '@/services/device';
import DeviceIcon from '@/assets/device.svg';
import qs from 'query-string';
function NodeSelector({
  width,
  parentNodeIsSelectable
}) {
  parentNodeIsSelectable = false;
  const buttonClicked = useSelector(state => state.nodeCount);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const pathname = history.location.pathname;
  const queryObj = qs.parseUrl(window.location.href).query;
  const [treeData, setTreeData] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const dispatch = useDispatch();
  const noLeaf = [];
  const fetchData = () => {
    setLoading(true);
    dispatch({
      type: 'update-nodeTreeNames',
      payload: {
        nodeTreeNames: []
      }
    });
    if (location.pathname === '/nms/application/appstate') {
      AppService.getAppsStateCount().then(data => {
        getDevices().then(res => {
          if (!res) {
            history.push(pathname);
            return;
          }
          res.forEach(item => {
            const findItem = data?.filter(i => i.mo === item.mo);
            if (findItem?.length > 0) {
              item.nodeName += '(' + findItem[0].count + ')';
            }
          });
          setTreeData(getTreeData(res));
          const allTreeArr = res.map(item => item.mo);
          dispatch({
            type: 'update-nodeTreeNames',
            payload: {
              nodeTreeNames: allTreeArr
            }
          });
          if (!queryObj.mo || !queryObj.nodeName) {
            setSelectedKeys([String(res[0]?.mo)]);
            queryObj.mo = res[0]?.mo;
            queryObj.nodeName = res[0]?.nodeName;
            res[0] ? history.push(pathname + '?' + qs.stringify(queryObj)) : history.push(pathname);
            return;
          }
          if (allTreeArr.indexOf(queryObj.mo) == -1) {
            setSelectedKeys([String(res[0]?.mo)]);
            queryObj.mo = res[0]?.mo;
            queryObj.nodeName = res[0]?.nodeName;
            res[0] ? history.push(pathname + '?' + qs.stringify(queryObj)) : history.push(pathname);
          }
        }).finally(() => {
          setLoading(false);
        });
      });
    } else {
      getDevices().then(res => {
        if (!res) {
          history.push(pathname);
          return;
        }
        setTreeData(getTreeData(res));
        const allTreeArr = res.map(item => item.mo);
        dispatch({
          type: 'update-nodeTreeNames',
          payload: {
            nodeTreeNames: allTreeArr
          }
        });
        if (!queryObj.mo || !queryObj.nodeName) {
          setSelectedKeys([String(res[0]?.mo)]);
          queryObj.mo = res[0]?.mo;
          queryObj.nodeName = res[0]?.nodeName;
          res[0] ? history.push(pathname + '?' + qs.stringify(queryObj)) : history.push(pathname);
          return;
        }
        if (allTreeArr.indexOf(queryObj.mo) == -1) {
          setSelectedKeys([String(res[0]?.mo)]);
          queryObj.mo = res[0]?.mo;
          queryObj.nodeName = res[0]?.nodeName;
          res[0] ? history.push(pathname + '?' + qs.stringify(queryObj)) : history.push(pathname);
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  };
  useEffect(() => {
    //fetchData();
    setSelectedKeys([queryObj.mo]);
  }, [location.pathname]);
  useEffect(() => {
    fetchData();
  }, [buttonClicked, location.pathname]);
  const getTreeData = data => {
    // Step 1: Group by groupName
    const grouped = data.reduce((acc, {
      mo,
      groupName,
      nodeName
    }) => {
      if (!acc[groupName]) {
        acc[groupName] = [];
      }
      acc[groupName].push({
        key: mo,
        name: nodeName
      });
      return acc;
    }, {});

    // Step 2: Convert to the desired format
    return Object.keys(grouped).map(groupName => ({
      key: groupName,
      name: groupName,
      children: grouped[groupName]
    }));
  };
  const selectTreeNode = (value, info) => {
    if (!info.node.props.isLeaf) return;
    setSelectedKeys(value);
    const mo = value;
    const nodeName = info.node.props.dataRef.name;
    history.push(pathname + '?' + qs.stringify({
      mo,
      nodeName
    }));
  };

  // const expandTreeNode = (value, info) => {
  //   const arr = [...expandedKeys];
  //   const index = arr.indexOf(info.node.key);
  //   if (index > -1) {
  //     arr.splice(index, 1);
  //   } else {
  //     arr.push(info.node.key);
  //   }
  //   setExpandedKeys(arr);
  // };

  const renderTitle = props => {
    if (props.isLeaf) {
      return /*#__PURE__*/React.createElement(_Tooltip, {
        position: "right",
        trigger: "hover",
        content: props.title
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/React.createElement(DeviceIcon, {
        width: 15
      }), /*#__PURE__*/React.createElement("span", null, props.title)));
    } else {
      return /*#__PURE__*/React.createElement(_Tooltip, {
        position: "right",
        trigger: "hover",
        content: props.title
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        },
        onClick: () => {
          return false;
        }
      }, /*#__PURE__*/React.createElement("span", null, props.title)));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles['device-node-selector'],
    style: {
      width
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['device-node-selector-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginLeft: -8
    }
  }, loading ? /*#__PURE__*/React.createElement(_Spin, {
    dot: true
  }) : null), treeData.length > 0 ? /*#__PURE__*/React.createElement(_Tree, {
    autoExpandParent: true,
    renderTitle: renderTitle,
    treeData: treeData,
    selectedKeys: selectedKeys
    // expandedKeys={expandedKeys}
    ,
    onSelect: selectTreeNode
    // onExpand={expandTreeNode}
    ,
    blockNode: true,
    className: styles['tree'],
    fieldNames: {
      key: 'key',
      title: 'name',
      children: 'children'
    }
  }) : /*#__PURE__*/React.createElement(_Empty, null)));
}
export default NodeSelector;